import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import {
  IGetDictionaryListReq,
  IGetDictionaryListRes,
  ICreateDictionaryReq,
  IUpdateDictionaryReq,
  IGetDictionaryValueListReq,
  IGetDictionaryValueListRes,
  ICreateDictionaryValueReq,
  IUpdateDictionaryValueReq,
  IGetDomainListRes,
  IGetDomainListReq,
  ICreateDomainConfig,
  IUpdateDomainConfig,
  IWarehousePageListItem,
  IV1LogisticsReq,
  IUpdateDictionaryStatusReq,
  IUpdateDictionaryValueStatusReq,
  IGetUserListReq,
  IGetUserListRes,
} from './type.d';

/**
 * 环境域名配置 - 列表
 */
export function getDomainList(params: IGetDomainListReq) {
  return http.get<IGetDomainListRes[]>({
    url: '/communal/domain/conf',
    loading: true,
    params,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 环境域名配置 - 列表
 */
export function getDomainEvlList(params = {}) {
  return http.get({
    url: '/communal/domain/conf/env-list',
    loading: true,
    params,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 环境域名配置 - 新增
 */
export function createDomainConfig(data: ICreateDomainConfig) {
  return http.post({
    url: '/communal/domain/conf',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 环境域名配置 - 修改
 */
export function updateDomainConfig(data: IUpdateDomainConfig) {
  return http.put({
    url: '/communal/domain/conf',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 环境域名配置 - 删除
 */
export function delDomainConfApi(id: string) {
  return http.delete({
    url: `/communal/domain/conf/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 字典管理 - 列表
 */
export function getDictionaryList(data: IGetDictionaryListReq) {
  return http.post<IGetDictionaryListRes[]>({
    url: '/ufg/web/v1/dict/page',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 字典管理 - 新增
 */
export function createDictionary(data: ICreateDictionaryReq) {
  return http.post({
    url: '/ufg/web/v1/dict/',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 字典管理 - 编辑
 */
export function updateDictionary(data: IUpdateDictionaryReq) {
  return http.put({
    url: `/ufg/web/v1/dict/${data.code}`,
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 字典管理 - 删除
 */
export function delDictionary(data: {
  dictCode: string;
}) {
  return http.delete({
    url: `/ufg/web/v1/dict/${data.dictCode}`,
    isCancelDuplicateUrlRequests: true,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}
/**
 * 字典管理 - 状态修改
 */
export function updateDictionaryStatus(data: IUpdateDictionaryStatusReq) {
  return http.put({
    url: '/ufg/web/v1/dict/enable',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 字典值管理 - 列表
 */
export function getDictionaryValueList(data: IGetDictionaryValueListReq) {
  return http.post<IGetDictionaryValueListRes>({
    url: '/ufg/web/v1/dict-value/page',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 字典值管理 - 创建
 */
export function createDictionaryValue(data: ICreateDictionaryValueReq) {
  return http.post({
    url: '/ufg/web/v1/dict-value/',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 字典值管理 - 更新
 */
export function updateDictionaryValue(data: IUpdateDictionaryValueReq) {
  return http.put({
    url: `/ufg/web/v1/dict-value/${data.dictValueId}`,
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 字典值管理 - 删除
 */
export function delDictionaryValue(data: {
  dictValueId: string;
}) {
  return http.delete({
    url: `/ufg/web/v1/dict-value/${data.dictValueId}`,
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 字典值管理 - 状态修改
 */
export function updateDictionaryValueStatus(data: IUpdateDictionaryValueStatusReq) {
  return http.put({
    url: '/ufg/web/v1/dict-value/enable',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 导入字典
 */
export function uploadDictionaryValueExcel(data: FormData) {
  return http.post({
    url: '/ufg/web/v1/dict-value/import-dict-value-info-excel',
    isCancelDuplicateUrlRequests: true,
    loading: true,
    data,
    headers: {
      'content-type': 'multipart/form-data',
    },
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 仓库地址 - 列表
 */
export function getWarehouseList(data = {}) {
  return http.post({
    url: '/communal/web/v1/warehouse/page',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 仓库地址 - 更新
 */
export function updateWarehouse(data: IWarehousePageListItem) {
  return http.put({
    url: '/communal/web/v1/warehouse',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 仓库地址 - 新增
 */
export function addWarehouse(data: IWarehousePageListItem) {
  return http.post({
    url: '/communal/web/v1/warehouse',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 仓库地址 - 删除
 */
export function deleteWarehouse(id: string) {
  return http.delete({
    url: `/communal/web/v1/warehouse/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 物流 - 列表
 */
export function getLogisticsList(params = {}) {
  return http.get({
    url: '/communal/web/v1/logistics/tree-all',
    loading: true,
    params,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 物流 - 新增
 */
export function addLogistics(data: IV1LogisticsReq) {
  return http.post({
    url: '/communal/web/v1/logistics',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 物流 - 修改
 */
export function updateLogistics(data: IV1LogisticsReq) {
  return http.put({
    url: '/communal/app/v1/logistics/update-logistics',
    loading: true,
    data,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 物流 - 删除
 */
export function deleteLogistics(id: string) {
  return http.delete({
    url: `/communal/web/v1/logistics/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
}

/**
 * 用户查询 - 列表
 */
export const getUserList = (params: IGetUserListReq) => {
  return http.get<IGetUserListRes[]>({
    url: '/cuckoo/web/v1/user/userInfo',
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.TIANGONG,
    params,
  });
};
